import { BasketballCoachesSlice } from '@hefe/store';
import { useAppDispatch } from '../../../../store/store';
import React, { useEffect } from 'react';

export default function CoachConflictsPage() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(BasketballCoachesSlice.fetchBasketballCoachesConflicts());
  }, []);

  return <div>hi</div>;
}
